import { UserPayload } from "types/auth.api";

export function redirectPage(
  user: UserPayload | null,
  isBusinessSetup?: boolean
) {
  if (!user?.is_profile_setup) {
    console.log("Calling Not Profile SetUP");
    return "/profile-setup";
  }

  if (!user?.is_company_profile_setup) {
    console.log("Calling Not Company Profile SetUP");
    if (!user?.is_businessSetUpCompleted) {
      console.log("Calling Not Business Profile SetUP");
      return "/business-profile-setup";
    } else {
      console.log("Calling Not Business address SetUP");
      return "/business-address";
    }
  }

  return null;
}
